import { useEffect } from "react";
import { Box } from "@mui/material";
import { useBreadcrumb } from "../contexts/BreadcrumbContext.jsx";
import NotificationsTable from "../components/tables/NotificationsTable.jsx";
import { PageHeader } from "../theme/components/index.js";

export function NotificationsPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Benachrichtigungen", path: "/notifications" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        pt: 0,
        pb: 6,
      }}
    >
      <PageHeader title="Benachrichtigungen" />

      {/* Notifications Table with integrated filter tabs */}
      <NotificationsTable
        variant="full"
        enablePagination={true}
        enableSorting={true}
        enableTopToolbar={true}
        enableBottomToolbar={true}
        enableHeader={true}
        showViewAllLink={false}
      />
    </Box>
  );
}
